<template>
  <div></div>
</template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        width: {
          name: 'width',
          defaultValue: 150,
          min: '50',
          max: '1500',
          labelDesc: 'height-content',
          callback: function() {
            vm.resources.width.defaultValue = this.value;
            vm.element.internal_config.width = this.value + 'px';
          }
        },
        zIndex: {
          name: 'zIndex',
          defaultValue: '',
          labelDesc: 'zIndex',
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          }
        },
        blogImageHeight: {
          name: 'blogImageHeight',
          defaultValue: '100',
          min: '0',
          max: '1100',
          labelDesc: 'blog-image-height',
          callback: function() {
            vm.resources.blogImageHeight.defaultValue = this.value;
            vm.element.internal_config.card.sizes.thumbnail.height = this.value + 'px';
          }
        },
        blogImageWidth: {
          name: 'blogImageWidth',
          defaultValue: '100',
          min: '0',
          max: '1100',
          labelDesc: 'blog-image-width',
          callback: function() {
            vm.resources.blogImageWidth.defaultValue = this.value;
            vm.element.internal_config.card.sizes.thumbnail.width = this.value + 'px';
          }
        },
        blogContentHeight: {
          name: 'blogContentHeight',
          defaultValue: '0',
          min: '10',
          max: '1100',
          labelDesc: 'blog-content-height',
          callback: function() {
            vm.resources.blogContentHeight.defaultValue = this.value;
            vm.element.internal_config.card.sizes.content.height = this.value + 'px';
          }
        },
        blogContentWidth: {
          name: 'blogContentWidth',
          defaultValue: '100',
          min: '0',
          max: '1100',
          labelDesc: 'blog-content-width',
          callback: function() {
            vm.resources.blogContentWidth.defaultValue = this.value;
            vm.element.internal_config.card.sizes.content.width = this.value + 'px';
          }
        },
        blogTitleHeight: {
          name: 'blogTitleHeight',
          defaultValue: '100',
          min: '0',
          max: '1100',
          labelDesc: 'blog-title-height',
          callback: function() {
            vm.resources.blogTitleHeight.defaultValue = this.value;
            vm.element.internal_config.card.sizes.title.height = this.value + 'px';
          }
        },
        blogTitleWidth: {
          name: 'blogTitleWidth',
          defaultValue: '100',
          min: '0',
          max: '1100',
          labelDesc: 'blog-title-width',
          callback: function() {
            vm.resources.blogTitleWidth.defaultValue = this.value;
            vm.element.internal_config.card.sizes.title.width = this.value + 'px';
          }
        },
        blogButtonDivHeight: {
          name: 'blogButtonDivHeight',
          defaultValue: '100',
          min: '0',
          max: '1100',
          labelDesc: 'blog-button-div-height',
          callback: function() {
            vm.resources.blogButtonDivHeight.defaultValue = this.value;
            vm.element.internal_config.card.sizes.buttonDiv.height = this.value + 'px';
          }
        },
        blogButtonDivWidth: {
          name: 'blogButtonDivWidth',
          defaultValue: '100',
          min: '0',
          max: '1100',
          labelDesc: 'blog-button-div-width',
          callback: function() {
            vm.resources.blogButtonDivWidth.defaultValue = this.value;
            vm.element.internal_config.card.sizes.buttonDiv.width = this.value + 'px';
          }
        },
        blogButtonHeight: {
          name: 'blogButtonHeight',
          defaultValue: '100',
          min: '0',
          max: '1100',
          labelDesc: 'blog-button-height',
          callback: function() {
            vm.resources.blogButtonHeight.defaultValue = this.value;
            vm.element.internal_config.card.sizes.button.height = this.value + 'px';
          }
        },
        blogButtonWidth: {
          name: 'blogButtonWidth',
          defaultValue: '100',
          min: '0',
          max: '1100',
          labelDesc: 'blog-button-width',
          callback: function() {
            vm.resources.blogButtonWidth.defaultValue = this.value;
            vm.element.internal_config.card.sizes.button.width = this.value + 'px';
          }
        },
        blogCardHeight: {
          name: 'blogCardHeight',
          defaultValue: '100',
          min: '0',
          max: '1100',
          labelDesc: 'blog-card-height',
          callback: function() {
            vm.resources.blogCardHeight.defaultValue = this.value;
            vm.element.internal_config.card.sizes.card.height = this.value + 'px';
          }
        },
        blogButtonBorderRadius: {
          name: 'blogButtonBorderRadius',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'blog-border-radius',
          callback: function() {
            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.blogButtonBorderRadius.defaultValue = value;
            vm.element.internal_config.card.sizes.button.borderRadius = value;
          }
        },
        blogCardBorderRadius: {
          name: 'blogCardBorderRadius',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'blog-border-radius',
          callback: function() {
            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.blogCardBorderRadius.defaultValue = value;
            vm.element.internal_config.card.sizes.card.borderRadius = value;
          }
        },
        blogThumbnailBorderRadius: {
          name: 'blogThumbnailBorderRadius',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'blog-border-radius',
          callback: function() {
            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.blogThumbnailBorderRadius.defaultValue = value;
            vm.element.internal_config.card.sizes.thumbnail.borderRadius = value;
          }
        },
        padding: {
          name: 'padding',
          defaultLeft: '15',
          defaultTop: '15',
          defaultRight: '15',
          defaultBottom: '15',
          min: '0',
          max: '100',
          labelDesc: 'padding',
          callback: function() {
            vm.resources.padding.defaultLeft = this.l;
            vm.element.internal_config.paddingLeft = this.l + 'px';

            vm.resources.padding.defaultTop = this.t;
            vm.element.internal_config.paddingTop = this.t + 'px';

            vm.resources.padding.defaultRight = this.r;
            vm.element.internal_config.paddingRight = this.r + 'px';

            vm.resources.padding.defaultBottom = this.b;
            vm.element.internal_config.paddingBottom = this.b + 'px';
          }
        },
        blogColor1: {
          name: 'blogColor1',
          defaultValue: '#ffffff',
          gradient: false,
          labelDesc: 'blog-color-1',
          callback: function() {
            vm.resources.blogColor1.defaultValue = this.colorValue;
            vm.element.internal_config.card.colors.color_1 = this.colorValue;
          }
        },
        blogColor2: {
          name: 'blogColor2',
          defaultValue: '#ffffff',
          gradient: false,
          labelDesc: 'blog-color-2',
          callback: function() {
            vm.resources.blogColor2.defaultValue = this.colorValue;
            vm.element.internal_config.card.colors.color_2 = this.colorValue;
          }
        },
        blogColor3: {
          name: 'blogColor3',
          defaultValue: '#ffffff',
          gradient: false,
          labelDesc: 'blog-color-3',
          callback: function() {
            vm.resources.blogColor3.defaultValue = this.colorValue;
            vm.element.internal_config.card.colors.color_3 = this.colorValue;
          }
        },
        blogColor4: {
          name: 'blogColor4',
          defaultValue: '#ffffff',
          gradient: false,
          labelDesc: 'blog-color-4',
          callback: function() {
            vm.resources.blogColor4.defaultValue = this.colorValue;
            vm.element.internal_config.card.colors.color_4 = this.colorValue;
          }
        },
        blogColor5: {
          name: 'blogColor5',
          defaultValue: '#ffffff',
          gradient: false,
          labelDesc: 'blog-color-5',
          callback: function() {
            vm.resources.blogColor5.defaultValue = this.colorValue;
            vm.element.internal_config.card.colors.color_5 = this.colorValue;
          }
        },
        blogTitleStyle: {
          name: 'blogTitleStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          showSizeMobile: true,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'blog-title-style',
          callback: function() {
            vm.resources.blogTitleStyle.defaultFamily = this.family;
            vm.element.internal_config.card.styles.title.family = this.family;

            vm.resources.blogTitleStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.card.styles.title.size = this.size + 'px';

            vm.resources.blogTitleStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.card.styles.title.sizeMobile = this.sizeMobile + 'px';

            vm.resources.blogTitleStyle.defaultColor = this.color;
            vm.element.internal_config.card.styles.title.color = this.color;

            vm.resources.blogTitleStyle.defaultAlign = this.align;
            vm.element.internal_config.card.styles.title.align = this.align;

            vm.resources.blogTitleStyle.defaultWeight = this.weight;
            vm.element.internal_config.card.styles.title.weight = this.weight;

            vm.resources.blogTitleStyle.defaultStyle = this.style;
            vm.element.internal_config.card.styles.title.style = this.style;

            vm.resources.blogTitleStyle.defaultStroke = this.stroke;
            vm.element.internal_config.card.styles.title.stroke = this.stroke;
          }
        },
        blogContentStyle: {
          name: 'blogContentStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          showSizeMobile: true,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'blog-content-style',
          callback: function() {
            vm.resources.blogContentStyle.defaultFamily = this.family;
            vm.element.internal_config.card.styles.content.family = this.family;

            vm.resources.blogContentStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.card.styles.content.size = this.size + 'px';

            vm.resources.blogContentStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.card.styles.content.sizeMobile = this.sizeMobile + 'px';

            vm.resources.blogContentStyle.defaultColor = this.color;
            vm.element.internal_config.card.styles.content.color = this.color;

            vm.resources.blogContentStyle.defaultAlign = this.align;
            vm.element.internal_config.card.styles.content.align = this.align;

            vm.resources.blogContentStyle.defaultWeight = this.weight;
            vm.element.internal_config.card.styles.content.weight = this.weight;

            vm.resources.blogContentStyle.defaultStyle = this.style;
            vm.element.internal_config.card.styles.content.style = this.style;

            vm.resources.blogContentStyle.defaultStroke = this.stroke;
            vm.element.internal_config.card.styles.content.stroke = this.stroke;
          }
        },
        blogButtonStyle: {
          name: 'blogButtonStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          showSizeMobile: false,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'blog-button-style',
          callback: function() {
            vm.resources.blogButtonStyle.defaultFamily = this.family;
            vm.element.internal_config.card.styles.button.family = this.family;

            vm.resources.blogButtonStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.card.styles.button.size = this.size + 'px';

            vm.resources.blogButtonStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.card.styles.button.sizeMobile = this.sizeMobile + 'px';

            vm.resources.blogButtonStyle.defaultColor = this.color;
            vm.element.internal_config.card.styles.button.color = this.color;

            vm.resources.blogButtonStyle.defaultAlign = this.align;
            vm.element.internal_config.card.styles.button.align = this.align;

            vm.resources.blogButtonStyle.defaultWeight = this.weight;
            vm.element.internal_config.card.styles.button.weight = this.weight;

            vm.resources.blogButtonStyle.defaultStyle = this.style;
            vm.element.internal_config.card.styles.button.style = this.style;

            vm.resources.blogButtonStyle.defaultStroke = this.stroke;
            vm.element.internal_config.card.styles.button.stroke = this.stroke;
          }
        },
        blogAuthorStyle: {
          name: 'blogAuthorStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          showSizeMobile: true,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'blog-author-style',
          callback: function() {
            vm.resources.blogAuthorStyle.defaultFamily = this.family;
            vm.element.internal_config.card.styles.author.family = this.family;

            vm.resources.blogAuthorStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.card.styles.author.size = this.size + 'px';

            vm.resources.blogAuthorStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.card.styles.author.sizeMobile = this.sizeMobile + 'px';

            vm.resources.blogAuthorStyle.defaultColor = this.color;
            vm.element.internal_config.card.styles.author.color = this.color;

            vm.resources.blogAuthorStyle.defaultAlign = this.align;
            vm.element.internal_config.card.styles.author.align = this.align;

            vm.resources.blogAuthorStyle.defaultWeight = this.weight;
            vm.element.internal_config.card.styles.author.weight = this.weight;

            vm.resources.blogAuthorStyle.defaultStyle = this.style;
            vm.element.internal_config.card.styles.author.style = this.style;

            vm.resources.blogAuthorStyle.defaultStroke = this.stroke;
            vm.element.internal_config.card.styles.author.stroke = this.stroke;
          }
        },
        blogCategoriesStyle: {
          name: 'blogCategoriesStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          showSizeMobile: false,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'blog-author-style',
          callback: function() {
            vm.resources.blogCategoriesStyle.defaultFamily = this.family;
            vm.element.internal_config.card.styles.categories.family = this.family;

            vm.resources.blogCategoriesStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.card.styles.categories.size = this.size + 'px';

            vm.resources.blogCategoriesStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.card.styles.categories.sizeMobile = this.sizeMobile + 'px';

            vm.resources.blogCategoriesStyle.defaultColor = this.color;
            vm.element.internal_config.card.styles.categories.color = this.color;

            vm.resources.blogCategoriesStyle.defaultAlign = this.align;
            vm.element.internal_config.card.styles.categories.align = this.align;

            vm.resources.blogCategoriesStyle.defaultWeight = this.weight;
            vm.element.internal_config.card.styles.categories.weight = this.weight;

            vm.resources.blogCategoriesStyle.defaultStyle = this.style;
            vm.element.internal_config.card.styles.categories.style = this.style;

            vm.resources.blogCategoriesStyle.defaultStroke = this.stroke;
            vm.element.internal_config.card.styles.categories.stroke = this.stroke;
          }
        }
      }
    };
  },
  methods: {
    setMinValuesData(resource, value) {
      this.resources[resource].min = parseInt(value);
    },
    setValuesData(data) {
      this.element = data;

      // sizes
      this.resources.blogImageHeight.defaultValue = data.internal_config.card.sizes.thumbnail.height;
      this.resources.blogImageWidth.defaultValue = data.internal_config.card.sizes.thumbnail.width;

      this.resources.blogContentHeight.defaultValue = data.internal_config.card.sizes.content.height;
      this.resources.blogContentWidth.defaultValue = data.internal_config.card.sizes.content.width;

      // title
      this.resources.blogTitleHeight.defaultValue = data.internal_config.card.sizes.title.width;
      this.resources.blogTitleWidth.defaultValue = data.internal_config.card.sizes.title.height;

      // button div
      this.resources.blogButtonDivHeight.defaultValue = data.internal_config.card.sizes.buttonDiv.height;
      this.resources.blogButtonDivWidth.defaultValue = data.internal_config.card.sizes.buttonDiv.width;

      // button
      this.resources.blogButtonHeight.defaultValue = data.internal_config.card.sizes.button.height;
      this.resources.blogButtonWidth.defaultValue = data.internal_config.card.sizes.button.width;

      // card
      this.resources.blogCardHeight.defaultValue = data.internal_config.card.sizes.card.height;


      // default
      this.resources.width.defaultValue = data.internal_config.width;
      this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
      this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
      this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
      this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);

      // titleStyle
      this.resources.blogTitleStyle.defaultFamily = data.internal_config.card.styles.title.family;
      this.resources.blogTitleStyle.defaultSize = data.internal_config.card.styles.title.size;
      this.resources.blogTitleStyle.defaultSizeMobile = data.internal_config.card.styles.title.sizeMobile;
      this.resources.blogTitleStyle.defaultColor = data.internal_config.card.styles.title.color;
      this.resources.blogTitleStyle.defaultAlign = data.internal_config.card.styles.title.align;
      this.resources.blogTitleStyle.defaultWeight = data.internal_config.card.styles.title.weight;
      this.resources.blogTitleStyle.defaultStyle = data.internal_config.card.styles.title.style;
      this.resources.blogTitleStyle.defaultStroke = data.internal_config.card.styles.title.stroke;

      // contentStyle
      this.resources.blogContentStyle.defaultFamily = data.internal_config.card.styles.content.family;
      this.resources.blogContentStyle.defaultSize = data.internal_config.card.styles.content.size;
      this.resources.blogContentStyle.defaultSizeMobile = data.internal_config.card.styles.content.sizeMobile;
      this.resources.blogContentStyle.defaultColor = data.internal_config.card.styles.content.color;
      this.resources.blogContentStyle.defaultAlign = data.internal_config.card.styles.content.align;
      this.resources.blogContentStyle.defaultWeight = data.internal_config.card.styles.content.weight;
      this.resources.blogContentStyle.defaultStyle = data.internal_config.card.styles.content.style;
      this.resources.blogContentStyle.defaultStroke = data.internal_config.card.styles.content.stroke;

      // button style
      this.resources.blogButtonStyle.defaultFamily = data.internal_config.card.styles.button.family;
      this.resources.blogButtonStyle.defaultSize = data.internal_config.card.styles.button.size;
      this.resources.blogButtonStyle.defaultSizeMobile = data.internal_config.card.styles.button.sizeMobile;
      this.resources.blogButtonStyle.defaultColor = data.internal_config.card.styles.button.color;
      this.resources.blogButtonStyle.defaultAlign = data.internal_config.card.styles.button.align;
      this.resources.blogButtonStyle.defaultWeight = data.internal_config.card.styles.button.weight;
      this.resources.blogButtonStyle.defaultStyle = data.internal_config.card.styles.button.style;
      this.resources.blogButtonStyle.defaultStroke = data.internal_config.card.styles.button.stroke;

      // border radius
      this.resources.blogCardBorderRadius.defaultValue = data.internal_config.card.sizes.card.borderRadius;
      this.resources.blogThumbnailBorderRadius.defaultValue = data.internal_config.card.sizes.thumbnail.borderRadius;
      this.resources.blogButtonBorderRadius.defaultValue = data.internal_config.card.sizes.button.borderRadius;

      // author style
      this.resources.blogAuthorStyle.defaultFamily = data.internal_config.card.styles.author.family;
      this.resources.blogAuthorStyle.defaultSize = data.internal_config.card.styles.author.size;
      this.resources.blogAuthorStyle.defaultSizeMobile = data.internal_config.card.styles.author.sizeMobile;
      this.resources.blogAuthorStyle.defaultColor = data.internal_config.card.styles.author.color;
      this.resources.blogAuthorStyle.defaultAlign = data.internal_config.card.styles.author.align;
      this.resources.blogAuthorStyle.defaultWeight = data.internal_config.card.styles.author.weight;
      this.resources.blogAuthorStyle.defaultStyle = data.internal_config.card.styles.author.style;
      this.resources.blogAuthorStyle.defaultStroke = data.internal_config.card.styles.author.stroke;

      // categories style
      this.resources.blogCategoriesStyle.defaultFamily = data.internal_config.card.styles.categories.family;
      this.resources.blogCategoriesStyle.defaultSize = data.internal_config.card.styles.categories.size;
      this.resources.blogCategoriesStyle.defaultSizeMobile = data.internal_config.card.styles.categories.sizeMobile;
      this.resources.blogCategoriesStyle.defaultColor = data.internal_config.card.styles.categories.color;
      this.resources.blogCategoriesStyle.defaultAlign = data.internal_config.card.styles.categories.align;
      this.resources.blogCategoriesStyle.defaultWeight = data.internal_config.card.styles.categories.weight;
      this.resources.blogCategoriesStyle.defaultStyle = data.internal_config.card.styles.categories.style;
      this.resources.blogCategoriesStyle.defaultStroke = data.internal_config.card.styles.categories.stroke;

      // colors
      this.resources.blogColor1.defaultValue = data.internal_config.card.colors.color_1;
      this.resources.blogColor2.defaultValue = data.internal_config.card.colors.color_2;
      this.resources.blogColor3.defaultValue = data.internal_config.card.colors.color_3;
      this.resources.blogColor4.defaultValue = data.internal_config.card.colors.color_4;
      this.resources.blogColor5.defaultValue = data.internal_config.card.colors.color_5;
    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Lists/Article/Resource.vue